'use client';
import { SignupForAssetDialog } from './SignupForAssetModal';
import React, { createContext, ReactNode, useContext, useState } from 'react';

const ContextSignupForAssetDialog = createContext<{ openSignupForAssetDialog: () => void }>({
  openSignupForAssetDialog: () => {},
});

export function WithSignupForAsset({ children, ticker }: { children: ReactNode; ticker: string }) {
  const [opened, setOpened] = useState(false);

  return (
    <ContextSignupForAssetDialog.Provider value={{ openSignupForAssetDialog: () => setOpened(true) }}>
      <SignupForAssetDialog opened={opened} ticker={ticker} close={() => setOpened(false)} />
      {children}
    </ContextSignupForAssetDialog.Provider>
  );
}

export function useSignupForAssetModal() {
  return useContext(ContextSignupForAssetDialog);
}
